import React from "react";

const AboutCompany = () => {
  return (
    <React.Fragment>
      {/* App-Solution-Section-Start */}
      <section className="h2_nh_about-area pt-100 pb-100 nh_light_bg nh_border_bottom">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="nh_about-img mr-15 mb-30 mb-lg-0">
                <img src="/images/about-us-4.png" alt="" className="w-100" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="nh_about-left ml-20">
                <div className="nh_section-area">
                  <span className="nh_section-subtitle">About us</span>
                  <h2 className="nh_section-title mb-15 pb-2">
                    Discover Mitra Recharge
                  </h2>
                  <p className="nh_section-text">
                    Welcome to Mitra Recharge, a trusted platform for all your
                    recharge needs. Powered by PANMITRA ONLINE SERVICE PRIVATE
                    LIMITED, we specialize in providing quick and secure Mobile,
                    DTH, and Google Play recharges. Our goal is to deliver a
                    seamless experience with fast transactions, attractive
                    commissions, and round-the-clock customer support. Whether
                    you're an individual or a business, Mitra Recharge offers a
                    simple, reliable, and rewarding solution for all your
                    digital recharge services..
                  </p>
                  <p className="nh_section-text mb-25 pb-2">
                    To become a leading digital recharge platform in India,
                    empowering individuals and businesses with seamless, secure,
                    and rewarding recharge solutions for Mobile, DTH, and Google
                    Play services.
                  </p>
                </div>
                <div className="nh_about-btn">
                  <a href="/about_us" className="nh_theme-btn">
                    Learn More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* App-Solution-Section-end */}
    </React.Fragment>
  );
};

export default AboutCompany;
